import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "share-guide" }
const _hoisted_2 = {
  key: 0,
  class: "share-note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("svg", {
      viewBox: "0 0 300 196",
      role: "img",
      "aria-label": "Chrome’s share picker: the Entire Screen tab, the Share with system audio switch turned on under the screen previews, and the Share with audio button",
      "font-family": "'Segoe UI', system-ui, -apple-system, sans-serif"
    }, [
      _createElementVNode("rect", {
        x: "1",
        y: "1",
        width: "298",
        height: "194",
        rx: "8",
        fill: "#ffffff",
        stroke: "#c4c7cc"
      }),
      _createElementVNode("text", {
        x: "12",
        y: "17",
        "font-size": "9.5",
        fill: "#202124",
        "font-weight": "600"
      }, "Choose what to share with superform.ironbook.com"),
      _createElementVNode("text", {
        x: "12",
        y: "37",
        "font-size": "10",
        fill: "#5f6368"
      }, "Chrome Tab"),
      _createElementVNode("text", {
        x: "82",
        y: "37",
        "font-size": "10",
        fill: "#5f6368"
      }, "Window"),
      _createElementVNode("text", {
        x: "134",
        y: "37",
        "font-size": "10",
        fill: "#1a73e8",
        "font-weight": "700"
      }, "Entire Screen"),
      _createElementVNode("line", {
        x1: "1",
        y1: "44.5",
        x2: "299",
        y2: "44.5",
        stroke: "#dadce0"
      }),
      _createElementVNode("rect", {
        x: "132",
        y: "42",
        width: "70",
        height: "3",
        fill: "#1a73e8"
      }),
      _createElementVNode("rect", {
        x: "127",
        y: "23",
        width: "81",
        height: "25",
        rx: "6",
        fill: "none",
        stroke: "#ea6a0e",
        "stroke-width": "2"
      }),
      _createElementVNode("circle", {
        cx: "220",
        cy: "35",
        r: "8",
        fill: "#c2410c"
      }),
      _createElementVNode("text", {
        x: "220",
        y: "38.5",
        "font-size": "10",
        "font-weight": "700",
        fill: "#fff",
        "text-anchor": "middle"
      }, "1"),
      _createElementVNode("rect", {
        x: "12",
        y: "53",
        width: "126",
        height: "50",
        rx: "4",
        fill: "#e8f0fe",
        stroke: "#1a73e8",
        "stroke-width": "2"
      }),
      _createElementVNode("rect", {
        x: "19",
        y: "58",
        width: "112",
        height: "40",
        rx: "2",
        fill: "#3c4043"
      }),
      _createElementVNode("rect", {
        x: "25",
        y: "63",
        width: "58",
        height: "29",
        rx: "1.5",
        fill: "#8ab4f8"
      }),
      _createElementVNode("rect", {
        x: "88",
        y: "63",
        width: "37",
        height: "18",
        rx: "1.5",
        fill: "#e8eaed"
      }),
      _createElementVNode("text", {
        x: "75",
        y: "114",
        "font-size": "8.5",
        fill: "#3c4043",
        "text-anchor": "middle"
      }, "Screen 1"),
      _createElementVNode("rect", {
        x: "150",
        y: "53",
        width: "126",
        height: "50",
        rx: "4",
        fill: "#f8f9fa",
        stroke: "#dadce0"
      }),
      _createElementVNode("rect", {
        x: "157",
        y: "58",
        width: "112",
        height: "40",
        rx: "2",
        fill: "#5f6368"
      }),
      _createElementVNode("rect", {
        x: "163",
        y: "63",
        width: "45",
        height: "29",
        rx: "1.5",
        fill: "#bdc1c6"
      }),
      _createElementVNode("text", {
        x: "213",
        y: "114",
        "font-size": "8.5",
        fill: "#3c4043",
        "text-anchor": "middle"
      }, "Screen 2"),
      _createElementVNode("rect", {
        x: "7",
        y: "121",
        width: "258",
        height: "26",
        rx: "13",
        fill: "#fff4ea",
        stroke: "#ea6a0e",
        "stroke-width": "2"
      }),
      _createElementVNode("path", {
        d: "M16 131h3.5l4.5-4v14l-4.5-4H16z",
        fill: "#3c4043"
      }),
      _createElementVNode("path", {
        d: "M26.5 130.5q3 3.5 0 7M28.8 128.2q5 5.8 0 11.6",
        fill: "none",
        stroke: "#3c4043",
        "stroke-width": "1.2",
        "stroke-linecap": "round"
      }),
      _createElementVNode("text", {
        x: "37",
        y: "137.5",
        "font-size": "10",
        fill: "#202124"
      }, "Share with system audio"),
      _createElementVNode("rect", {
        x: "232",
        y: "128.5",
        width: "22",
        height: "11",
        rx: "5.5",
        fill: "#1a73e8"
      }),
      _createElementVNode("circle", {
        cx: "248.5",
        cy: "134",
        r: "4",
        fill: "#ffffff"
      }),
      _createElementVNode("circle", {
        cx: "278",
        cy: "134",
        r: "8",
        fill: "#c2410c"
      }),
      _createElementVNode("text", {
        x: "278",
        y: "137.5",
        "font-size": "10",
        "font-weight": "700",
        fill: "#fff",
        "text-anchor": "middle"
      }, "2"),
      _createElementVNode("rect", {
        x: "147",
        y: "161",
        width: "92",
        height: "27",
        rx: "13.5",
        fill: "none",
        stroke: "#ea6a0e",
        "stroke-width": "2"
      }),
      _createElementVNode("rect", {
        x: "150",
        y: "164",
        width: "86",
        height: "21",
        rx: "10.5",
        fill: "#1a73e8"
      }),
      _createElementVNode("text", {
        x: "193",
        y: "177.5",
        "font-size": "9",
        fill: "#ffffff",
        "font-weight": "700",
        "text-anchor": "middle"
      }, "Share with audio"),
      _createElementVNode("rect", {
        x: "244",
        y: "164",
        width: "48",
        height: "21",
        rx: "10.5",
        fill: "#ffffff",
        stroke: "#dadce0"
      }),
      _createElementVNode("text", {
        x: "268",
        y: "177.5",
        "font-size": "9",
        fill: "#1a73e8",
        "text-anchor": "middle"
      }, "Cancel"),
      _createElementVNode("circle", {
        cx: "133",
        cy: "174.5",
        r: "8",
        fill: "#c2410c"
      }),
      _createElementVNode("text", {
        x: "133",
        y: "178",
        "font-size": "10",
        "font-weight": "700",
        fill: "#fff",
        "text-anchor": "middle"
      }, "3")
    ], -1)),
    _cache[1] || (_cache[1] = _createStaticVNode("<ol class=\"share-steps\" data-v-0a782622><li data-v-0a782622><b aria-hidden=\"true\" data-v-0a782622>1</b><span data-v-0a782622>Click <strong data-v-0a782622>Entire Screen</strong></span></li><li data-v-0a782622><b aria-hidden=\"true\" data-v-0a782622>2</b><span data-v-0a782622>Turn on <strong data-v-0a782622>Share with system audio</strong></span></li><li data-v-0a782622><b aria-hidden=\"true\" data-v-0a782622>3</b><span data-v-0a782622>Click <strong data-v-0a782622>Share with audio</strong></span></li></ol>", 1)),
    (_ctx.note)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.note), 1))
      : _createCommentVNode("", true)
  ]))
}